import { useMutation } from "react-query";

import type { AppointmentV2, PutAppointmentV2Args } from "api/services/appointment/schemas/appointment_v2";
import { useApiClient } from "api/useApiClient";

export const usePutAppointmentV2 = () => {
  const client = useApiClient();

  return useMutation<AppointmentV2, Error, PutAppointmentV2Args>({ mutationFn: args => client.putAppointmentV2(args) });
};
